<template lang="pug">
#v-form.form.container
  h2.form__title 填寫資料，索取白皮書
  form.form__form(@submit.prevent='submit')
    .form__information.form-information
      label.form-information__field
        span.form-information__label *姓名
        input.form-information__input(v-model='name', :disabled='submitted', name='name', type='text', required)
      label.form-information__field
        span.form-information__label *公司名稱
        input.form-information__input(v-model='company', :disabled='submitted', name='company', type='text', required)
      label.form-information__field
        span.form-information__label *手機
        input.form-information__input(v-model='phone', :disabled='submitted', name='phone', type='tel', required)
      label.form-information__field
        span.form-information__label *職稱
        input.form-information__input(v-model='position', :disabled='submitted', name='position', type='text', required)
      label.form-information__field
        span.form-information__label *連絡信箱
        input.form-information__input(v-model='email', :disabled='submitted', name='email', type='email', required)
    .form__consent.form-consent
      h3.form-consent__title 感謝您參與本次測驗，調查得獎者我們將會在調查結束後兩週內以電話、email 通知。
      .form-consent__sub 抽獎注意事項詳見以下資訊：
      ol.form-consent__content
        li 活動贈品以實際提供為準，不得要求更換或兌換現金。
        li 參加活動者資料以網頁登錄內容為準，若填寫資料不正確造成無法聯繫或贈品無法準確送達則視為自動棄權，獎項將不另外補發。
        li 依中華民國稅法規定，中獎價值在新台幣NT$1,000( 含 ) 元以上者，贈與物品的價值將併入得獎者個人綜合所得稅申報，請中獎人配合繳交身分證影印本作為申報依據。
        li 贈品一經寄送後，如有遺失、損毀等情事發生，主辦單位不負補發之責。
        li 參加活動者若有冒用第三人之資料或是未填寫正確之中文姓名、連絡電話及可收平信或掛號之郵寄地址時，主辦單位得取消其兌換資格。
        li 參加活動者於送出資料參加本活動之同時，即同意受本活動辦法及注意事項之規範，如有違反本活動辦法及注意事項者，主辦單位得取消其參加或兌換資格，並對於任何破壞本活動之行為保留法律追訴權。
        li 參加活動者提供內容資料後，即表示同意並接受本主辦單位將該資料做為內部行銷企畫之使用，主辦單位不會將該資料提供與其他第三人使用。
        li 相關內容同意由主辦單位擁有最後審閱與決定刊登權利。參加活動者必須同意及遵守本活動辦法所訂之條款及約定，內容包括本活動網站之使用、資料交換以及可能產生的任何行為。
        li 參加活動者若以惡意之電腦程式或其他明顯違反活動公平性之方式，意圖混淆或影響活動結果者，一經主辦單位發現或經第三人檢舉經查證屬實，主辦單位有權立即取消其得獎資格，除追回獎品外，並對於任何破壞本活動之行為保留法律追訴權。
        li 本活動如有任何因電腦、網路、電話、技術或其他不可歸責於主辦單位之事由，而使參與本活動者所登錄之資料有遺失、錯誤、無法辨識或毀損所導致資料無效之情況，主辦單位不負任何責任，參加活動者亦不得異議。
        li 對於本活動直接或間接產生和涉及的任何損失或損害，包括收件地址錯誤、郵務或其他事項等，主辦單位不負相關賠償責任。
    label.form__agreement.form-agreement
      input(v-model='privacy', :value='true', :disabled='submitted', name='privacy', type='checkbox', required)
      p.form-agreement__content
        | 送出本張表單後，本人即同意KEYSIGHT得以上述方式，及並按照KEYSIGHT隱私權聲明中所述內容處理本人的資料，若貴客戶不願意我們使用您於此處所提供之資訊，將無法向您提供任何KEYSIGHT之產品，服務，白皮書或其它商品行銷訊息。
        br
        | 此外，我瞭解在活動期間，為將來推廣用途，KEYSIGHT可能會拍攝許多相片或進行現場串流直播。
        br
        br
        | 因應 5/25 歐盟 GDPR 新個資法規生效，TechOrange 將會配合在 GDPR 適用的情況下，遵照 GDPR 所列各項條款，落實使用者的個資保護。詳參：
        a.form-agreement__content(href='https://gdpr-info.eu/', target='_blank') https://gdpr-info.eu/
    button.form__button(:disabled='submitted', type='submit') 送出檢測
</template>

<script>
export default {
  name: 'Form',
  data() {
    return {
      submitted: false,
      name: '',
      company: '',
      phone: '',
      position: '',
      email: '',
      privacy: false,
    }
  },
  methods: {
    submit() {
      this.submitted = true
      this.$http.post('/api/participant/insert', {
        name: this.name,
        company: this.company,
        phone: this.phone,
        position: this.position,
        email: this.email,
        privacy: this.privacy,
      }).then(() => {
        alert('感謝您的參與資料已送出，按確認即可獲得KEYSIGHT 毫米波量測白皮書')
        window.open(process.env.BASE_URL + '是德 mmwave e-book.pdf')
      }).catch((err) => {
        this.submitted = false
        alert(err.response.data.errorMessage)
        setTimeout(() => $(`input[name=${err.response.data.errorColumn}]`, this.$el).focus(), 200)
      })
    },
  },
}
</script>

<style lang="sass" scoped>
.form
  padding-bottom: 60px
  padding-top: 60px
  &__title
    +font(32px, #E50029, 32px, 2.13px, 500)
    margin-bottom: 60px
    text-align: center
    &::after
      border-bottom: 2px solid #E50029
      content: ''
      display: block
      margin-left: auto
      margin-right: auto
      padding-bottom: 34px
      width: 80px
  &__information
    +flexbox(space-between, null, null, wrap)
    margin-bottom: 24px
  &__consent
    margin-bottom: 40px
  &__agreement
    margin-bottom: 40px
  &__button
    +font(28px, white, null, 3px, 500)
    +size(230px, 80px)
    background-color: #E50029
    display: block
    margin-left: auto
    margin-right: auto
.form-information
  &__field
    +flexbox(space-between, center)
    +font(20px, #5A5A5A, null, 2.22px, 500)
    margin-bottom: 29px
    width: 430px
  &__input
    +size(310px, 28px)
    background-color: white
.form-consent
  background-color: white
  height: 190px
  overflow: scroll
  padding: 25px 75px
  &__title
    +font(20px, #E50029, null, .71px)
    margin-bottom: 14px
    text-align: center
  &__sub
    +font(16px, #333333, 26px, .57px)
  &__content
    +font(16px, #333333, 26px, .57px)
.form-agreement
  display: flex
  &__content
    +font(14px, #5A5A5A, 24px, 2.22px)

@media (max-width: 991px)
  .form
    padding-bottom: 40px
    padding-top: 40px
    &__title
      +font(20px, null, 28px, 1px)
      margin-bottom: 40px
      &::after
        padding-bottom: 24px
        width: 55px
    &__information
      +flexbox(flex-start, null, column, nowrap)
    &__consent
      margin-bottom: 20px
    &__agreement
      margin-bottom: 30px
    &__button
      +font(18px, null, null, 2.69px)
      +size(170px, 50px)
  .form-information
    margin-bottom: 17px
    &__field
      +font(14px, null, null, 1.55px)
      margin-bottom: 21px
      width: 100%
    &__label
      flex: none
      width: 90px
    &__input
      flex: 1
      height: 20px
  .form-consent
    height: 140px
    padding: 10px 15px
    &__title
      +font(12px, null, 16px, 0)
      margin-bottom: 10px
      text-align: left
    &__sub
      +font(12px, null, 18px, 0)
    &__content
      +font(12px, null, 18px, 0)
  .form-agreement
    &__content
      +font(12px, null, 18px, 1.55px)
</style>
